import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
/**
 * @export
 * Individual table cell component that renders a single cell within a table row.
 * Handles rendering of regular data cells and special action columns.
 *
 * @example
 * ```tsx
 * <TableCell
 *   row={rowData}
 *   column={columnDef}
 *   renderCell={(row, col) => <span>{row[col.id]}</span>}
 * />
 * ```
 */
const TableCell = memo(({ row, column, renderCell }) => {
    const renderValue = () => {
        var _a;
        if (renderCell) {
            return renderCell(row, column);
        }
        if (typeof (column === null || column === void 0 ? void 0 : column.renderColumn) !== 'function') {
            return row[column.id] || null;
        }
        return (_a = column === null || column === void 0 ? void 0 : column.renderColumn) === null || _a === void 0 ? void 0 : _a.call(column, row);
    };
    const handleClick = (e) => {
        var _a;
        // List of special columns that should stop event propagation
        const isSpecialColumn = [
            '__editColumn__',
            '__deleteColumn__',
            '__selectColumn__',
            '__expandColumn__',
            '__actionsColumn__',
            '__editActionsColumn__',
            '__dragHandleColumn__'
        ].includes(column.id);
        if (isSpecialColumn || !!(column === null || column === void 0 ? void 0 : column.onClickColumn)) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (!isSpecialColumn && !!(column === null || column === void 0 ? void 0 : column.onClickColumn)) {
            (_a = column === null || column === void 0 ? void 0 : column.onClickColumn) === null || _a === void 0 ? void 0 : _a.call(column, e, row, column);
        }
    };
    return (_jsx("div", { className: "uxpcore_table__cell", style: {
            minWidth: column.minWidth,
            width: column.width,
            maxWidth: column.maxWidth
        }, onClick: handleClick, children: renderValue() }));
});
export default TableCell;
